import xmlDoc from "refractor/xml-doc";
export default xmlDoc;